/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '@shared/models';

@Component({
    selector: 'app-user-deactivation-confirmation',
    templateUrl: './user-deactivation-confirmation.component.html',
    styleUrls: ['./user-deactivation-confirmation.component.scss'],
    standalone: false
})
export class UserDeactivationConfirmationComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: User }
  ) {
  }
}
